import type { IHomepageResources } from "./HomepageResources";

const HomepageResourcesEn: IHomepageResources = {
    cashbackSectionTitle: "Cashback",
    cashbackSectionSubTitle:
        "Make safe online shopping and get <br>a <b>refund of part of the money</b> you have spent",
    cashbackSectionButton: "See more",
    cashbackSectionBrandsTitle: "Cashback stores",
    cashbackSectionMoreButton: "More stores",

    discountsSectionTitle: "<b>Discounts</b> and promo codes",
    discountsSectionSubtitle:
        "<b>Find the latest deals and promo</b> codes in your favourite stores. goodie offers you the latest offers, promotions, events and promo codes in shopping malls, online shops and restaurants nearby. Click on the specific discount or go to the dedicated page of your favourite brand.",
    discountsSectionButton: "Browse Deals",

    flyersSectionTitle: "<b>Latest</b> promotional flyers",
    flyersSectionSubtitle:
        "<b>Check the latest promotional flyers</b> from stores nearby! Always be up to date and do not miss hot promotions or sales! Promotional flyers of all your favorite stores in one place.",
    flyersSectionBrandsMoreButton: "More Flyers",
    flyersSectionBrandList: "Popular Flyers Brands",
    flyersSectionButton: "Browse flyers",

    appSectionOffersTitle: "Get more with <br/><b>goodie app!</b>",
    blogSectionTitle: "<b>Shopping Inspirations</b>",
    goodieInfo: "<b>goodie:</b> always the latest flyers, discount codes, cashback, promotions.",

    shoppingMallsSection: {
        title: "<b>Promotions in shopping malls</b>",
        buttonText: "See More",
    },
    accessibility: {
        cashbackAll: "See all cashback stores",
        yourCashback: "Check all about cashback",
        discountsAll: "See all available discounts",
        shoppingMallAll: "See all shopping mall",
        flyersAll: "See all latest flyers",
    },
};

export default HomepageResourcesEn;
